import React from "react";
import { Icon } from "components/Icon/Icon";
import cx from "classnames";
import { UncontrolledTooltip } from "reactstrap";
import { useTranslate } from "hooks";
import { useHasProductChanged, useProductActions } from "stores/product";

export const RestoreProductButton = () => {
  const translate = useTranslate();
  const isProductChanged = useHasProductChanged();
  const actions = useProductActions();
  return (
    <>
      <Icon
        data-testid="product-configurator-rotate-left-icon"
        iconName="arrow-rotate-left-regular"
        onClick={actions.restoreNode}
        id="product-configurator-rotate-left-icon"
        className={cx("icon-20 text-gray-700 cursor-pointer", {
          "cursor-not-allowed opacity-20 pe-none": !isProductChanged,
        })}
      />
      <UncontrolledTooltip
        placement="top"
        data-testid="product-configurator-rotate-left-tooltip"
        target="product-configurator-rotate-left-icon"
      >
        {translate("PRODUCT_CONFIGURATOR_RESET_BUTTON_TOOLTIP")}
      </UncontrolledTooltip>
    </>
  );
};
